import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import useRTSPContext from "../../../redux/context/RTSPProvider";
import CameraTile from "./CameraTile";

export default function CartRtspViewer({ site, cartId,isPhoneSize }) {
  const { cameraMap, getStream } = useRTSPContext();
  const names = Object.entries(cameraMap?.[site]?.[cartId] || {});

  if (!names.length) {
    return (
      <Typography sx={{ p: 2 }} align="center">
        No live RTSP cameras found.
      </Typography>
    );
  }

  return (
    <Box
      sx={{
        width: "100%",
        flex: "1 1 auto",         // fill the 80vh container
        display: "flex",
        flexDirection: "column",
        position: "relative",     // for the close button
        minHeight: 0,             // allow children to shrink
        overflow: "hidden",       // clip overflow
      }}
    >

      {/* Header */}
      <Typography variant="h6" align="center" gutterBottom sx={{ mt: 4 }}>
        RTSP Live Cameras — Cart {cartId}
      </Typography>

      {/* Grid of tiles */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr", // one column
          gridAutoRows: "1fr",        // equal‐height rows
          gap: 1,
          flex: "1 1 auto",           // fill remaining height
          minHeight: 0,               // allow grid to shrink
          overflow: "hidden",         // clip content
        }}
      >
        {names.map(([name, pid]) => (
          <CameraTile
            key={pid}
            name={name}
            producerId={pid}
            getStream={getStream}
            sx={{ minHeight: 0, overflow: "hidden" }}
            isPhoneSize={isPhoneSize}
          />
        ))}
      </Box>
    </Box>
  );
}
